<template>
    <div class="ticker" :class="{'up': up, 'down': down, 'no-change': noChange}">
        <p class="ticker-row">
            <span class="ticker-symbol">{{ ticker.name }}</span>
            <span class="ticker-index">{{ ticker.price }}</span>
        </p>
        <div class="ticker-row">
            <v-icon
                small
                color="white"
                style="vertical-align: inherit;">{{ growthIcon }}</v-icon>
            <div style="text-align: right; display: inline; float: right">
                <span class="ticker-index-growth">{{ growthSign(ticker.change) }}{{ ticker.change }}</span>
                <span class="ticker-index-growth-percentage">{{ growthSign(ticker.change_percentage) }}{{ ticker.change_percentage }}%</span>
            </div>
        </div>
        <p class="ticket-row" style="margin-bottom: 0px;">
            <span class="ticket-last-update-time">Last Updated {{  lastUpdated }}</span>
        </p>
    </div>
</template>

<script>
import moment from 'moment';
import 'moment-timezone';

export default {
    props: {
        ticker: {
            type: Object,
            default: () => {}
        }
    },

    computed: {
        lastUpdated() {
            return moment(this.ticker.feed_updated_at * 1000).tz( "America/New_York").format('YYYY-MM-DD hh:mm A z');
        },
        growthIcon() {
            if (this.up) {
                return 'mdi-arrow-up-bold';
            }

            if (this.down) {
                return 'mdi-arrow-down-bold';
            }

            return '';
        },
        down() {
            return this.ticker.change < 0;
        },
        up() {
            return this.ticker.change > 0;
        },
        noChange() {
            return this.ticker.change === 0;
        }
    },

    methods: {
        growthSign(growth) {
            return growth > 0 ? '+' : '';
        }
    }
}
</script>

<style>
    .ticker {
        width: 100%;
        color: white;
        background-color: #007850;
        padding: 2px 10px 2px 10px;
        display: inline-block;
    }
    .ticket.up,.ticker.no-change{
        background-color: #007850;
    }
    .ticker.down  {
        background-color: red;
    }
    .ticker-symbol {
        font-weight: bolder;
    }
    .ticker-index-growth {
        font-weight: bold;
    }
    .ticker-index {
        float: right;
    }
    .ticker-index-growth {
        margin-right: 10px;
    }
    .ticker-index-growth-percentage {

    }
    .ticker-row {
        width: 100%;
        margin-bottom: 8px !important;
    }
    .ticket-last-update-time {
        font-size: 12px;
    }

</style>

